var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8273 26.4829L5.37891 44.6898L11.172 43.0346L13.6548 48.0001L21.103 30.6208L12.8273 26.4829Z",
    fill: "#DE4C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0336 25.6553L22.7578 30.6208L30.2061 48.0001L32.6888 43.0346L38.4819 44.6898L31.0336 25.6553Z",
    fill: "#DE4C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8273 26.4829L10.0879 33.1781L10.2286 33.2194L11.9996 38.7146L17.6438 37.5063L18.0079 37.8373L21.103 30.6208L12.8273 26.4829Z",
    fill: "#C74436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7578 30.6208L25.853 37.8373L26.2171 37.5063L31.8612 38.7146L33.6322 33.2194L33.955 33.1201L31.0336 25.6553L22.7578 30.6208Z",
    fill: "#C74436"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9314 0L26.2183 3.87309L31.8624 2.65659L33.6335 8.16L39.1286 9.93103L37.9204 15.5752L41.7935 19.8621L37.9204 24.149L39.1286 29.7931L33.6335 31.5641L31.8624 37.0593L26.2183 35.851L21.9314 39.7241L17.6445 35.851L12.0004 37.0593L10.2293 31.5641L4.72593 29.7931L5.94243 24.149L2.06934 19.8621L5.94243 15.5752L4.72593 9.93103L10.2293 8.16L12.0004 2.65659L17.6445 3.87309L21.9314 0Z",
    fill: "#FDB62F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6209 6.62063C42.3395 4.92244 41.0087 3.59166 39.3105 3.31031C41.0087 3.02897 42.3395 1.69819 42.6209 0C42.9022 1.69819 44.233 3.02897 45.9312 3.31031C44.233 3.59166 42.9022 4.92234 42.6209 6.62063Z",
    fill: "#FDB62F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7935 19.8619L37.9204 15.575L39.1287 9.93089L34.8501 8.54883C30.2073 21.3681 19.1757 28.6178 10.5273 32.4826L12.0004 37.0591L17.6446 35.8509L21.9315 39.724L26.2184 35.8509L31.8625 37.0591L33.6335 31.564L39.1287 29.793L37.9204 24.1488L41.7935 19.8619Z",
    fill: "#FFA83D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9656 18.2071C15.1375 18.2071 13.6553 16.7249 13.6553 14.8967C13.6553 13.0686 15.1375 11.5864 16.9656 11.5864C18.7937 11.5864 20.2759 13.0686 20.2759 14.8967C20.2759 16.7249 18.7937 18.2071 16.9656 18.2071ZM16.9656 13.2415C16.0511 13.2415 15.3104 13.9822 15.3104 14.8966C15.3104 15.8111 16.0511 16.5518 16.9656 16.5518C17.88 16.5518 18.6207 15.8111 18.6207 14.8966C18.6207 13.9822 17.88 13.2415 16.9656 13.2415Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7244 28.9654C25.8962 28.9654 24.4141 27.4832 24.4141 25.655C24.4141 23.8269 25.8962 22.3447 27.7244 22.3447C29.5525 22.3447 31.0347 23.8269 31.0347 25.655C31.0347 27.4831 29.5525 28.9654 27.7244 28.9654ZM27.7244 23.9998C26.8099 23.9998 26.0692 24.7405 26.0692 25.6549C26.0692 26.5694 26.8099 27.3101 27.7244 27.3101C28.6388 27.3101 29.3795 26.5694 29.3795 25.6549C29.3795 24.7405 28.6389 23.9998 27.7244 23.9998Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 26.2419L28.3066 14.6553L27.1363 13.4849L15.5497 25.0715L16.72 26.2419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreDiscount);
export default __webpack_public_path__ + "static/media/store-discount.d437f0dc6bdbafa7943906abc678b7b6.svg";
export { ForwardRef as ReactComponent };